import React from 'react';
import { FacebookIcon, YoutubeIcon, PhoneIcon, MapPinIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full" style={{
    backgroundColor: '#0f2318'
  }} aria-label="Site footer" data-id="element-170">
      {/* Gold top border */}
      <div className="w-full h-1" style={{
      backgroundColor: '#c8a84b'
    }} data-id="element-171" />

      <div className="max-w-6xl mx-auto px-4 md:px-8 py-12 md:py-16" data-id="element-172">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10" data-id="element-173">
          {/* Brand column */}
          <div className="lg:col-span-1" data-id="element-174">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/FentonLakes-logo.png" alt="Fenton Lakes Sportsman's Club" className="h-14 w-auto mb-4" data-id="element-175" />
            <p className="text-sm leading-relaxed mb-5" style={{
            color: '#7a9a8a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-176">
              Serving our community by protecting natural resources and
              supporting fellow sportsmen since 1953.
            </p>
            <div className="flex gap-3" data-id="element-177">
              <a href="https://www.facebook.com/FentonLakesSportsmansClub" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-9 h-9 rounded-lg flex items-center justify-center transition-all hover:opacity-80" style={{
              backgroundColor: 'rgba(255,255,255,0.08)',
              color: '#a0b8a8'
            }} data-id="element-178">
                <FacebookIcon size={16} data-id="element-179" />
              </a>
              <a href="https://www.youtube.com/FentonLakesSportsmansClub" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="w-9 h-9 rounded-lg flex items-center justify-center transition-all hover:opacity-80" style={{
              backgroundColor: 'rgba(255,255,255,0.08)',
              color: '#a0b8a8'
            }} data-id="element-180">
                <YoutubeIcon size={16} data-id="element-181" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-182">
            <h3 className="text-sm font-bold uppercase tracking-wider mb-4" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#c8a84b'
          }} data-id="element-183">
              Quick Links
            </h3>
            <ul className="space-y-2.5" data-id="element-184">
              {[{
              label: 'Home',
              href: '/'
            }, {
              label: 'Calendar',
              href: '/10.html'
            }, {
              label: 'Clubhouse Rental',
              href: '/12.html'
            }, {
              label: 'Range Rules',
              href: '/6.html'
            }, {
              label: 'Newsletter',
              href: '/48.html'
            }, {
              label: 'Contact Us',
              href: '/5.html'
            }, {
              label: 'Photo Tour',
              href: '/14.html'
            }, {
              label: 'Privacy Policy',
              href: '/35.html'
            }].map(({
              label,
              href
            }) => <li key={href} data-id="element-185">
                  <a href={href} className="text-sm transition-colors hover:opacity-80" style={{
                color: '#7a9a8a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-186">
                    {label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Activities */}
          <div data-id="element-187">
            <h3 className="text-sm font-bold uppercase tracking-wider mb-4" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#c8a84b'
          }} data-id="element-188">
              Activities
            </h3>
            <ul className="space-y-2.5" data-id="element-189">
              {[{
              label: 'Sporting Clays',
              href: '/18.html'
            }, {
              label: 'Cowboy Action Shooting',
              href: '/16.html'
            }, {
              label: 'Steel Challenge',
              href: '/56.html'
            }, {
              label: '3-D Archery',
              href: '/17.html'
            }, {
              label: 'Jr. Rifle',
              href: '/15.html'
            }, {
              label: 'PPC Shooting',
              href: '/19.html'
            }, {
              label: 'Bowling Pin Shoots',
              href: '/42.html'
            }].map(({
              label,
              href
            }) => <li key={href} data-id="element-190">
                  <a href={href} className="text-sm transition-colors hover:opacity-80" style={{
                color: '#7a9a8a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-191">
                    {label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-192">
            <h3 className="text-sm font-bold uppercase tracking-wider mb-4" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#c8a84b'
          }} data-id="element-193">
              Contact
            </h3>
            <div className="space-y-4" data-id="element-194">
              <div className="flex items-start gap-3" data-id="element-195">
                <MapPinIcon size={15} className="flex-shrink-0 mt-0.5" style={{
                color: '#4a7c59'
              }} data-id="element-196" />
                <p className="text-sm" style={{
                color: '#7a9a8a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-197">
                  1140 Butcher Rd
                  <br data-id="element-198" />
                  Fenton, MI 48430-1232
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-199">
                <PhoneIcon size={15} style={{
                color: '#4a7c59'
              }} data-id="element-200" />
                <a href="tel:8106297964" className="text-sm transition-colors hover:opacity-80" style={{
                color: '#7a9a8a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-201">
                  (810) 629-7964
                </a>
              </div>
              <div className="flex items-center gap-3" data-id="element-202">
                <MailIcon size={15} style={{
                color: '#4a7c59'
              }} data-id="element-203" />
                <a href="mailto:flsportsmansclub@gmail.com" className="text-sm transition-colors hover:opacity-80" style={{
                color: '#7a9a8a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-204">
                  flsportsmansclub@gmail.com
                </a>
              </div>
            </div>

            {/* Emblem */}
            <div className="mt-6" data-id="element-205">
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/FLSC%20NEW%20ALPHA%20Outline.png167x167.png" alt="FLSC Emblem" className="w-16 h-16 object-contain opacity-60" data-id="element-206" />
            </div>

            {/* Apply CTA */}
            <div className="mt-5" data-id="element-207">
              <a href="/49.html" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg font-semibold text-sm transition-all hover:opacity-90" style={{
              backgroundColor: '#c8a84b',
              color: '#1a1a1a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-208">
                Apply for Membership
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4" style={{
        borderTop: '1px solid rgba(255,255,255,0.08)'
      }} data-id="element-209">
          <p className="text-xs" style={{
          color: '#4a6a5a',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-210">
            © {new Date().getFullYear()} Fenton Lakes Sportsman's Club. All
            rights reserved.
          </p>
          <div className="flex gap-4" data-id="element-211">
            <a href="/35.html" className="text-xs transition-colors hover:opacity-80" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-212">
              Privacy Policy
            </a>
            <a href="/6.html" className="text-xs transition-colors hover:opacity-80" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-213">
              Range Rules
            </a>
            <a href="https://my-store-c0b81b.creator-spring.com" target="_blank" rel="noopener noreferrer" className="text-xs transition-colors hover:opacity-80" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-214">
              Store
            </a>
          </div>
        </div>
      </div>
    </footer>;
}